import {
  createBrowserRouter,
  createRoutesFromElements,
  Route,
} from "react-router-dom";
import { Outlet } from "react-router-dom";

import Layout from "./components/layout";
import Dashboard from "./pages/dashboard";
import Purchase from "./pages/purchase";
import Usages from "./pages/usages";
import NgnUsages from "./pages/ngn-usages";
import Withdraws from "./pages/withdraws";
import Payment from "./pages/payment";
import Settings from "./pages/settings";
import ChangePassword from "./pages/settings/change-password";
import ChangeAddress from "./pages/settings/change-address";
import ChangeIdentity from "./pages/settings/change-identity";
import Request from "./pages/request";
import RequestTd from "./pages/request-td";
import RequestFd from "./pages/request-fd";
import Ngn from "./pages/ngn-file/ngn";
import Result from "./pages/purchase/result";
import SignUp from "./pages/signup";
import SignUpPayment from "./pages/signup/payment";
import SignUpPurchase from "./pages/signup/purchase";
import SignUpUploadImage from "./pages/signup/upload-image";
import NgnSignUpSelectline from "./pages/signup/ngn/selectLine";
import Tickets from "./pages/ticket/tickets";
import RegisterTicket from "./pages/ticket/register-Ticket";
import Services from "./pages/services/services";
import PurchaseChannel from "./pages/purchase/ngn-channel";
import Payments from "./pages/payments";
import RegisterBankReceipt from "./pages/payment/register-bank-receipt";
import Withdraw from "./pages/withdraw";
import SpeedTest from "./pages/speedTest/speed-test";
import SpeedTestResult from "./pages/speedTest/speed-test-result";
import LandingPayment from "./pages/landing-page";
import PayPage from "./pages/Pay";
import { AuthContextProvider } from "./components/auth-context";
import Shop from "./pages/shop";
import ShopUploadImage from "./pages/shop/upload-image";
import ShopPayment from "./pages/shop/shop-payment";
import ShopPurchase from "./pages/shop/shop-purchase";
import CellPhoneForm from "./pages/shop/shop-cellPhone";
import VerifyNumber from "./pages/shop/verify-number";
import ShopSignUp from "./pages/shop/shop-signUp";
import ChangeNumberLayout from "./pages/signup/change-number-layout";
import ChangeUserName from "./pages/settings/change-userName";
import Contacts from "./pages/contact/contacts";
import RegisterContact from "./pages/contact/register-contact";
import EditContact from "./pages/contact/edit-contact";
import TicketDetail from "./pages/ticket/ticket-details";
const router = createBrowserRouter(
  createRoutesFromElements(
    <>
      <Route
        path="/"
        element={
          <AuthContextProvider>
            <Layout />
          </AuthContextProvider>
        }
      >
        <Route
          path="contacts"
          element={<Contacts />}
          handle={{ title: "لیست افراد مرتبط" }}
        />
        <Route
          path="registerContact"
          element={<RegisterContact />}
          handle={{ title: "ثبت افراد مرتبط" }}
        />
        <Route path="/editContact/:id" element={<EditContact />} />

        <Route index element={<Dashboard />} handle={{ title: "داشبورد" }} />
        <Route
          path="/pay/:lineId"
          element={<PayPage />}
          handle={{ title: "پرداخت" }}
        />
        <Route
          path="/landing-payment/:receiptId"
          element={<LandingPayment />}
          handle={{ title: "درگاه پرداخت" }}
        />
        <Route path="purchase">
          <Route
            path=":type"
            element={<Purchase />}
            handle={{
              getTitle: (params: { type?: string }) => {
                const titles = {
                  ip: "خریدآی پی",
                  packages: "خرید ترافیک",
                  service: "خرید سرویس",
                };
                const key = params.type;
                if (key && key in titles) {
                  return titles[key as keyof typeof titles];
                }
                return "خرید";
              },
            }}
          />

          <Route
            path="ngnChannel"
            element={<PurchaseChannel />}
            handle={{ title: "خرید NGN کانال" }}
          />
          <Route
            path="result/:receiptId"
            element={<Result />}
            handle={{ title: "نتیجه خرید" }}
          />
        </Route>

        <Route
          path="payment/:receiptId"
          element={<Payment />}
          handle={{ title: "پرداخت" }}
        />
        <Route
          path="usages"
          element={<Usages />}
          handle={{ title: "کارکرد ADSL" }}
        />
        <Route
          path="ngnUsages"
          element={<NgnUsages />}
          handle={{ title: "کارکرد NGN" }}
        />
        <Route
          path="withdraws"
          element={<Withdraws />}
          handle={{ title: "لیست خریدها" }}
        />
        <Route
          path="withdraw-detail/:id"
          element={<Withdraw />}
          handle={{ title: "جزئیات خرید" }}
        />
        <Route
          path="payments"
          element={<Payments />}
          handle={{ title: "پرداخت ها" }}
        />
        <Route
          path="speedTest"
          element={<SpeedTest />}
          handle={{ title: "تست سرعت" }}
        />
        <Route
          path="speedTest/result"
          element={<SpeedTestResult />}
          handle={{ title: "نتیجه تست سرعت" }}
        />
        <Route
          path="registerTicket"
          element={<RegisterTicket />}
          handle={{ title: "ثبت تیکت" }}
        />
        <Route
          path="tickets"
          element={<Tickets />}
          handle={{ title: "تیکت‌ ها" }}
        />
        <Route
          path="ticket-details/:id"
          element={<TicketDetail />}
          handle={{ title: "جزئیات تیکت" }}
        />
        <Route
          path="services"
          element={<Services />}
          handle={{ title: "سرویس‌ ها" }}
        />
        <Route
          path="registerBankReceipt"
          element={<RegisterBankReceipt />}
          handle={{ title: "ثبت فیش بانکی" }}
        />
        <Route path="request">
          <Route
            path="adsl"
            element={<Request />}
            handle={{ title: "درخواست سرویس ADSL" }}
          />
          <Route
            path="td"
            element={<RequestTd />}
            handle={{ title: "درخواست سرویس TD-LTE" }}
          />
          <Route
            path="fd"
            element={<RequestFd />}
            handle={{ title: "درخواست سرویس FD-LTE" }}
          />
          <Route
            path="ngn"
            element={<Ngn />}
            handle={{ title: "درخواست سرویس NGN" }}
          />
        </Route>
        <Route path="settings" handle={{ title: "تنظیمات" }}>
          <Route index element={<Settings />} handle={{ title: "تنظیمات" }} />
          <Route
            path="password"
            element={<ChangePassword />}
            handle={{ title: "تغییر رمز عبور" }}
          />
          <Route
            path="address"
            element={<ChangeAddress />}
            handle={{ title: "تغییر آدرس" }}
          />
          <Route
            path="identity"
            element={<ChangeIdentity />}
            handle={{ title: "تغییر مشخصات هویتی" }}
          />
          <Route
            path="userName"
            element={<ChangeUserName />}
            handle={{ title: "تغییرنام کاربری (تلفن همراه)" }}
          />
        </Route>
      </Route>

      <Route
        path="/signup"
        element={
          <AuthContextProvider>
            <Outlet />
          </AuthContextProvider>
        }
      >
        <Route
          index
          element={<SignUp medium={30} />}
          handle={{ title: "ثبت‌ نام TD-LTE" }}
        />
        <Route
          path="Adsl"
          element={<SignUp medium={0} />}
          handle={{ title: "ثبت‌ نام ADSL" }}
        />
        <Route
          path="Tdlte"
          element={<SignUp medium={30} />}
          handle={{ title: "ثبت‌ نام TD-LTE" }}
        />
        <Route
          path="Fdlte"
          element={<SignUp medium={31} />}
          handle={{ title: "ثبت‌ نام FD-LTE" }}
        />
         <Route
          path="Package"
          element={<SignUp medium={41} />}
          handle={{ title: "ثبت‌ نام بسته اشتراکی" }}
        />
        <Route
          path="uploadImage"
          element={<SignUpUploadImage />}
          handle={{ title: "آپلود تصویر" }}
        />
        <Route
          path="purchase"
          element={<SignUpPurchase />}
          handle={{ title: "خرید اولیه" }}
        />
        <Route
          path="payment/:receiptId"
          element={<SignUpPayment />}
          handle={{ title: "پرداخت ثبت‌ نام" }}
        />
        <Route path="ngn">
          <Route
            index
            element={<SignUp medium={40} />}
            handle={{ title: "ثبت‌ نام NGN" }}
          />
          <Route
            path="uploadImage"
            element={<SignUpUploadImage />}
            handle={{ title: "آپلود تصویر NGN" }}
          />
          <Route
            path="selectLine"
            element={<NgnSignUpSelectline />}
            handle={{ title: "انتخاب خط NGN" }}
          />
          <Route
            path="purchase"
            element={<SignUpPurchase />}
            handle={{ title: "خرید NGN" }}
          />
          <Route
            path="payment/:receiptId"
            element={<SignUpPayment />}
            handle={{ title: "پرداخت NGN" }}
          />
        </Route>
        <Route
          path="changeNumber"
          element={<ChangeNumberLayout />}
          handle={{ title: "ثبت شماره" }}
        />
      </Route>

      <Route
        path="/shop"
        element={
          <AuthContextProvider>
            <Outlet />
          </AuthContextProvider>
        }
      >
        <Route index element={<Shop />} handle={{ title: "ثبت‌ نام TD-LTE" }} />
        <Route
          path="signUp"
          element={<ShopSignUp />}
          handle={{ title: "ثبت‌ نام" }}
        />
        <Route
          path="uploadImage"
          element={<ShopUploadImage />}
          handle={{ title: "آپلود تصویر" }}
        />
        <Route
          path="purchase"
          element={<ShopPurchase />}
          handle={{ title: "انتخاب سرویس" }}
        />
        <Route
          path="payment/:receiptId"
          element={<ShopPayment />}
          handle={{ title: "پرداخت سرویس" }}
        />
        <Route
          path="selectLine"
          element={<NgnSignUpSelectline />}
          handle={{ title: "انتخاب خط NGN" }}
        />
        <Route
          path="cellPhone"
          element={<CellPhoneForm />}
          handle={{ title: "ثبت شماره همراه" }}
        />
        <Route
          path="verifyNumber"
          element={<VerifyNumber />}
          handle={{ title: "فعالسازی" }}
        />
      </Route>
    </>
  )
);

export default router;
